import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import Modal from '../../common/components/Modal';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import Button from '../../common/components/Button';
export default class InfoModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "info", '');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.loadInfo();
  }
  className() {
    return 'InfoModal Modal--large';
  }
  title() {
    return app.translator.trans('core.admin.dashboard.info_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.loading ? m("div", {
      className: "InfoModal-loading"
    }, m(LoadingIndicator, null)) : m("div", null, m("div", {
      className: "InfoModal-actions"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: this.copyToClipboard.bind(this)
    }, app.translator.trans('core.admin.dashboard.info_modal.copy_button'))), m("pre", {
      className: "InfoModal-content"
    }, m("code", null, this.info))));
  }
  copyToClipboard() {
    navigator.clipboard.writeText(this.info).then(() => {
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('core.admin.dashboard.info_modal.copy_success'));
    }, () => {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('core.admin.dashboard.info_modal.copy_error'));
    });
  }
  async loadInfo() {
    try {
      var _response$data;
      const response = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/system-info/system'
      });
      this.info = ((_response$data = response.data) == null || (_response$data = _response$data.attributes) == null ? void 0 : _response$data.content) || 'No info available';
    } catch (error) {
      this.info = 'Error loading info: ' + error.message;
    }
    this.loading = false;
    m.redraw();
  }
}
flarum.reg.add('core', 'admin/components/InfoModal', InfoModal);